import { ref, toRef, toRefs } from "vue";

/** 1 -> true , 2 -> false */
export const apiNumberBooleanMap = {
  toBoolean(data?: string) {
    if (!data) return;
    return { 1: true, 2: false }[data];
  },
  toNumber(data?: boolean) {
    if (!data) return;
    return data ? 1 : 2;
  },
};

export const getAuthUrl = (url: string) => {
  const token = localStorage.getItem('token');
  if (!token) return url;
  return url + (url.includes('?') ? '&' : '?') + `token=${token}`;
}